import { AvailableMissions } from './AvailableMissions';
import '../../../styles/adventures/missions.css';

const MissionsPage = () => {
  return (
    <div className="missions-page">
      <AvailableMissions />
    </div>
  );
};

export default MissionsPage;
